import React, { Fragment } from 'react'


const Filter = ({ id, register, handleSubmit, onReset, districts = [], stages = [], filters }) => {

  return (
    <form className="map__filter" onSubmit={handleSubmit}>
      <ul>
        <li>
          <input type="text" placeholder="Search" {...register('keywords', {
            value: filters.keywords
          })} inputMode="search" id={`keywords__${id}`} />
          <label htmlFor={`keywords__${id}`}>Search by title or keyword</label>
        </li>
        {districts.length > 0 && (
        <li>
          <select id={`district__${id}`} {...register('district')}>
            <option value="">All</option>
            {districts.map(district => <option key={district} value={district}>{district}</option>)}
          </select>
          <label htmlFor={`district__${id}`}>Search by district</label>
        </li>
        )}
        {/*stages.length > 0 && (
        <li>
          <div className="radios">
          {stages.map(stage => (
            <Fragment key={stage}>
              <label htmlFor={`stage__${stage}`}>
                <input type="radio" {...register('stage')} id={`stage__${stage}`} defaultValue={stage} />
                <span>{stage}</span>
              </label>
            </Fragment>
          ))}
          </div>
        </li>
          )*/}
      </ul>

      <div className="map__filter-buttons">
        <button type="submit">Submit</button>
        <button type="button" onClick={onReset}>Reset</button>
      </div>
    </form>
  )
}
export default Filter
